<div class="sortable-container">
  <div class="header-section">
    <button type="button" class="gms-btn primary me-5" (click)="onConfirmSortOrder()">
      Confirm Sort Order
    </button>
    <div class="me-3">
      <label class="fw-bold m-0">
        <input type="checkbox" class="form-check-input" [(ngModel)]="isSelectAll" (change)="onSelectAll()">
        Select All
      </label>
    </div>
    <span class="delete-icon"><i class="pi pi-trash" (click)="onDelete()"></i></span>
  </div>
  <ul class="sortable-list">
    @for (item of itemsList; track item; let i = $index) {
      <li class="item" draggable="true"
        (dragstart)="onDragStart($event, i)" (dragover)="onDragOver($event)" (drop)="onDrop($event, i)"
        (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)">
        <input [(ngModel)]="item.is_selected" (change)="onItemSelect($event,i)" type="checkbox"
          id="{{ 'cb' + item?.sortorder }}" />
          <img [width]="configObj.item_width" [height]="configObj.item_width" alt="emoji"
            src="/bingo_shared_assets/{{item?.path}}" id="{{ 'emoticon_' + i }}">
            @if (item.show_edit_icon) {
              <div class="edit-icon-bg" (click)="onItemEdit(content,item)">
                <span class="edit-icon"></span>
              </div>
            }
            @if (item.enable_preview) {
              <div class="mt-2 text-center">
                <div class="d-none" id="{{ 'anim-preview_' + i }}">{{item.title}}</div>
                <i class="pi pi-eye" (click)="showPreview(item, i)"></i>
              </div>
            }
          </li>
        }
      </ul>
    </div>

    <ng-template #content let-modal>
      <div class="modal-header">
        <h4 class="modal-title mb-0" id="modal-title">Add Shortcut Key</h4>
        <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="d-flex">
          <label class="mt-2 mb-0 me-3" for="shortcut">Add Shortcut Key</label>
          <input class="form-control col-6" type="text" [(ngModel)]="shortcutKey"
            (keyup)="validateShortcutKey($event)" id="shortcut" />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="gms-btn primary" (click)="onUpdate()">
            UPDATE
          </button>
          <button type="button" class="gms-btn secondary" (click)="modal.dismiss('cancel click')">
            CANCEL
          </button>
        </div>
      </ng-template>